import currency from "currency.js";
import { CLUB_CATCH_URL, CLUB_EVENT_ID } from "@cart-app/consts";
import { CartClubSubscriptionOption } from "@cart-app/generated/graphql";

export const formatClubItem = (option: CartClubSubscriptionOption) => ({
  id: option.id,
  uri: CLUB_CATCH_URL,
  quantity: 1,
  title: option.title,
  totalPrice: option.price,
  offer: {
    id: option.id,
  },
  metadata: {
    eventId: CLUB_EVENT_ID,
    source_position: 1,
    source_type: null, // no source_type returned for club item
  },
});

export const formatPrice = (price: number) => {
  return currency(price / 100).format(true);
};

export const formatPriceWithFreeText = (price: number, freeText = "Free") => {
  return price === 0 ? freeText : formatPrice(price);
};

type Quantity = {
  name: string;
  value: string;
  disabled: boolean;
};

type GenerateQuantityArrayProps = {
  selectedQuantity: number;
  maxQuantity: number;
};

export const generateQuantityArray = ({
  selectedQuantity,
  maxQuantity,
}: GenerateQuantityArrayProps): Quantity[] => {
  const maxSelection =
    selectedQuantity > maxQuantity ? selectedQuantity : maxQuantity;
  return Array.from({ length: maxSelection }, (_x, index) => ({
    name: (index + 1).toString(),
    value: (index + 1).toString(),
    disabled: index + 1 > maxQuantity,
  }));
};
